module.exports = __webpack_public_path__ + "media/images/favicons/apple-touch-icon-cb704187f060484ed2d53e1f944cf965.png";